import PropTypes from "prop-types"
import React, {useState} from "react"
import {useTranslation} from "react-i18next"
import {
  DownloadButton,
  FieldDate,
  List,
  ListItemArticle,
  Pagination,
  SearchField,
  SelectField
} from "~/components/"
import {withUserFeedback} from "~/helpers/"
import {useApi, useDebounce} from "~/hooks/"

export const ArticleList = ({locationId, filterByExpiryDate = true}) => {
  const {t} = useTranslation()
  const endpoint = "/articles"
  const [params, setParams] = useState({
    "search[query]": "",
    "search[start_expiry_date]": null,
    "search[end_expiry_date]": null,
    "search[article_stock_filter]": "stocked_in",
    "search[location_id]": locationId ? locationId : null,
    page: 0
  })
  const paramsQueryString = new URLSearchParams(params).toString()

  const setPage = page => setParams({...params, page})
  const setStartExpiryDate = date =>
    setParams({...params, "search[start_expiry_date]": date, page: 0})
  const setEndExpiryDate = date =>
    setParams({...params, "search[end_expiry_date]": date, page: 0})
  const setOnlyShowToBeStockedInArticles = value =>
    setParams({
      ...params,
      "search[article_stock_filter]": value
    })

  const [timestamp, setTimestamp] = useState(+new Date())
  const reload = () => setTimestamp(+new Date())
  const [query, setQuery] = useState("")

  useDebounce(query, 1000, () => {
    setParams({
      ...params,
      "search[query]": query,
      page: 0
    })
  })

  const data = useApi(
    endpoint,
    {
      params,
      headers: {
        Accept: "application/vnd.shelf.v2"
      }
    },
    {timestamp}
  )
  const articles = data && data.items
  const totalPages = data && data.total_pages

  return (
    <div className="sh-searchable-list">
      <div className="searchbar" style={{alignItems: "flex-end"}}>
        <SearchField
          onChange={setQuery}
          placeholder={t("articles.list.searchPlaceholder")}
        />
        {!!filterByExpiryDate && (
          <React.Fragment>
            <FieldDate
              label={t("articles.filter.fromDate")}
              onChange={setStartExpiryDate}
              name="from"
            />
            <FieldDate
              label={t("articles.filter.toDate")}
              onChange={setEndExpiryDate}
              name="to"
            />
          </React.Fragment>
        )}
        {!!!locationId && (
          <SelectField
            label={t("articles.filter.stock")}
            name="article_stock_filter"
            options={[
              {id: null, name: t("articles.filter.stockOptions.all")},
              {
                id: "stocked_in",
                name: t("articles.filter.stockOptions.stockedIn")
              },
              {
                id: "not_stocked_in",
                name: t("articles.filter.stockOptions.notStockedIn")
              },
              {
                id: "stocked_out",
                name: t("articles.filter.stockOptions.stockedOut")
              }
            ]}
            onChange={setOnlyShowToBeStockedInArticles}
          />
        )}
        <DownloadButton
          label={t("articles.list.download", {format: "(.xlsx)"})}
          endpoint={`/articles.xlsx?${paramsQueryString}`}
          v2
          filename="filtered_articles.xlsx"
          mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          automaticRetry
          key={JSON.stringify(params) + "xlsx"}
        />
        <DownloadButton
          label={t("articles.list.download", {format: "(.csv)"})}
          endpoint={`/articles.csv?${paramsQueryString}`}
          v2
          filename="filtered_articles.csv"
          mimeType="text/csv"
          automaticRetry
          key={JSON.stringify(params) + "csv"}
        />
      </div>

      <div className="results">
        {withUserFeedback(
          () => (
            <React.Fragment>
              <List
                items={articles}
                itemRenderer={ListItemArticle}
                update={reload}
              >
                <p>{t("articles.list.noResults")}</p>
              </List>
              <Pagination
                currentPage={params.page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            </React.Fragment>
          ),
          [data]
        )}
      </div>
    </div>
  )
}

ArticleList.propTypes = {
  filterByExpiryDate: PropTypes.bool.isRequired,
  locationId: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/views/list/ArticleList.js